<template>
  <Navbar :center-text="$t('RegistrationView.register')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container container-login mt-4 d-flex justify-content-center align-items-center">
    <form @submit.prevent="handleRegistration">
      <div class="row">
        <div class="col-12 form-group mb-4">
          <label for="email"
                 class="form-label">
            {{ $t('email') }}
          </label>
          <input v-model="email"
                 type="text"
                 class="form-control rounded-pill"
                 id="email"
                 :placeholder="$t('enterEmail')"
                 required/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-sm-12 form-group mb-4">
          <label for="firstname"
                 class="form-label">
            {{ $t('firstname') }}
          </label>
          <input v-model="firstname"
                 type="text"
                 class="form-control rounded-pill"
                 id="firstname"
                 :placeholder="$t('enterFirstname')"
                 required/>
        </div>

        <div class="col-md-6 col-sm-12 form-group mb-4">
          <label for="lastname"
                 class="form-label">
            {{ $t('lastname') }}
          </label>
          <input v-model="lastname"
                 type="text"
                 class="form-control rounded-pill"
                 id="lastname"
                 :placeholder="$t('enterLastname')"
                 required/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-sm-12 form-group mb-4">
          <label for="birthyear"
                 class="form-label">
            {{ $t('RegistrationView.birthyear') }}
          </label>
          <multiselect placeholder=""
                       class="rounded-pill"
                       v-model="selectedBirthyear"
                       :options="availableBirthyears"
                       :custom-label="yearSelectLabel"
                       :multiple="false"
                       :searchable="true"
                       :close-on-select="true"
                       :clear-on-select="true"
                       :show-label="false"
                       track-by="id"
                       required></multiselect>
        </div>
        <div class="col-md-6 col-sm-12 form-group mb-4">
          <label for="country"
                 class="form-label">
            {{ $t('RegistrationView.country') }}
          </label>
          <multiselect placeholder=""
                       class="rounded-pill"
                       v-model="selectedCountry"
                       :options="availableCountries"
                       :custom-label="countrySelectLabel"
                       :multiple="false"
                       :searchable="true"
                       :close-on-select="true"
                       :clear-on-select="true"
                       :show-label="false"
                       track-by="id"
                       required></multiselect>
        </div>
      </div>

      <div class="row">
        <div class="col-12 form-group mb-4">
          <label for="sex"
                 class="form-label">
            {{ $t('RegistrationView.sex') }}
          </label>
          <p>
            <label class="mx-1">
              <input type="radio"
                     name="sex"
                     id="man"
                     value="male"
                     v-model="selectedSex"
                     checked/>
              {{ $t('RegistrationView.man') }}
            </label>
            <label class="mx-1">
              <input type="radio"
                     name="sex"
                     id="woman"
                     value="female"
                     v-model="selectedSex"/>
              {{ $t('RegistrationView.woman') }}
            </label>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 form-group mb-4">
          <label for="password"
                 class="form-label">
            {{ $t('password') }}
          </label>
          <input v-model="password"
                 type="password"
                 class="form-control rounded-pill"
                 id="password"
                 :placeholder="$t('enterPassword')"
                 required/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 form-group mb-4">
          <label for="confirmPassword" class="form-label">{{ $t('RegistrationView.confirmPassword') }}</label>
          <input v-model="repeatPassword"
                 type="password"
                 class="form-control rounded-pill"
                 id="repeatPassword"
                 :placeholder="$t('RegistrationView.repeatYourPassword')"
                 required/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 form-group mb-4">
          <input type="checkbox"
                 class="mx-1"
                 id="agreement"
                 required/>
          <label for="agreement">
            {{ $t('RegistrationView.iAgree') }}&nbsp;<a href="#" data-bs-toggle="modal" data-bs-target="#termsAndConditionsModal">{{ $t('RegistrationView.termsAndConditions') }}</a>
          </label>
        </div>

        <div class="modal fade"
             id="termsAndConditionsModal"
             tabindex="-1">
          <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('RegistrationView.termsAndConditions') }}</h5>
                <button type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
              </div>
              <div class="modal-body align-content-start text-start">
                <p>{{ this.termsAndConditions }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 mb-4">
          <button type="submit"
                  class="btn btn-success rounded-pill mb-4 w-100">
            <i class="bi bi-person-plus-fill"></i>
            {{ $t('RegistrationView.register') }}
          </button>
        </div>
      </div>
    </form>
  </div>
  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "../../components/Navbar.vue";
import Footerbar from "../../components/Footerbar.vue";
import {getAllCountries, getToC, postRegistration} from "@/utils";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      termsAndConditions: "",
      email: "",
      firstname: "",
      lastname: "",
      selectedBirthyear: "",
      availableBirthyears: [],
      selectedCountry: "",
      availableCountries: [],
      selectedSex: "male",
      password: "",
      repeatPassword: "",
      errorMessage: "",
      message: this.$t('RegistrationView.registrationInfo'),
      messageType: "info",
    };
  },
  components: {
    Footerbar,
    Navbar,
    Multiselect,
  },
  async mounted() {
    let currentYear = new Date().getFullYear();
    let firstYear = currentYear - 100;
    for (let i = currentYear; i > firstYear; i--) {
      this.availableBirthyears.push({label: i, id: i});
    }

    let countriesResponse = await getAllCountries();
    if (countriesResponse.status === 200) {
      this.availableCountries = countriesResponse.data;
    } else {
      this.message = countriesResponse.response.data.message;
      this.messageType = "danger";
    }

    let tocResponse = await getToC();
    if (tocResponse.status === 200) {
      this.termsAndConditions = tocResponse.data.terms_and_conditions;
    } else {
      this.message = tocResponse.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    async handleRegistration() {
      let response = await postRegistration({
        email: this.email,
        firstname: this.firstname,
        lastname: this.lastname,
        birthyear: this.selectedBirthyear,
        country: this.selectedCountry,
        sex: this.selectedSex,
        password: this.password,
        repeatPassword: this.repeatPassword,
        language: this.currentLanguage,
      });
      if (response.status === 201) {
        const encodedEmail = btoa(this.email);
        this.$router.push({
          name: "activation",
          params: {email: encodedEmail},
        });
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },
    yearSelectLabel({label, id}) {
      return `${label}`;
    },
    countrySelectLabel({id, name, code}) {
      return `${name}`;
    },
  }
};
</script>

